"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Line = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _animations = require("../styles/animations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Line = _styledComponents.default.div`
    height: 1px;
    overflow: hidden;
    position: relative;

    &::before {
        display: block;
        position: absolute;
        content: '';
        left: -200px;
        width: 200px;
        height: 1px;
        background-color: var(--vcs-color--primary);
        animation: ${_animations.lineLoading} 2s linear infinite;
    }
`;
exports.Line = Line;